import React from 'react';
import { Helmet } from 'react-helmet-async';
import PublicLayout from '../components/PublicLayout';

const CookiePolicy: React.FC = () => {
  return (
    <PublicLayout>
      <Helmet>
        <title>Cookie Policy | Manatomy AI</title>
        <meta name="description" content="Cookie Policy for Manatomy AI - how we use cookies and similar technologies." />
      </Helmet>
      <div className="max-w-3xl mx-auto px-4 lg:px-6 py-12">
        <div className="prose prose-gray max-w-none space-y-6 text-secondary">
          <section>
            <h1 className="text-3xl font-semibold text-primary mb-6">Cookie Policy</h1>
            <ul className="text-sm mb-2">
              <li>
                <strong>Website:</strong>
                <a 
                  href="https://ai.themanatomy.com"
                  className="text-primary hover:underline"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ai.themanatomy.com
                </a>
              </li>
            </ul>
            <p>
              This Cookie Policy explains how Manatomy uses cookies and similar tracking technologies on our platform.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">What are Cookies?</h2>
            <p>
              Cookies are small text files stored on your device to enhance website functionality and user experience.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Types of Cookies We Use</h2>
            <ul className="list-disc list-inside ml-4">
              <li>
                <strong>Essential Cookies:</strong><br />
                Required for platform operation, security, and login functionality.
              </li>
              <li>
                <strong>Analytics Cookies:</strong><br />
                Used to analyze user behavior and improve performance (e.g., traffic analysis tools).
              </li>
              <li>
                <strong>Marketing Cookies:</strong><br />
                Used for retargeting and advertising campaigns (e.g., social media pixels).
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Purpose of Cookies</h2>
            <ul className="list-disc list-inside">
              <li>Improve platform performance</li>
              <li>Measure engagement</li>
              <li>Personalize user experience</li>
              <li>Support marketing campaigns</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Third-Party Cookies</h2>
            <p>
              Some cookies may be placed by third-party service providers such as analytics or advertising partners.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Managing Cookies</h2>
            <ul className="list-disc list-inside">
              <li>Adjust browser settings</li>
              <li>Reject non-essential cookies via banner</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p>
              <span className="font-semibold text-red-600">Note:</span> Disabling essential cookies may affect platform functionality.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Cookie Consent</h2>
            <p>
              Upon first visit, users are presented with a cookie banner allowing acceptance or rejection of non-essential cookies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-medium text-primary mb-3">Policy Updates</h2>
            <p>
              We may update this Cookie Policy periodically.
            </p>
            <p>
              For questions, contact:&nbsp;
              <a href="mailto:help@themanatomy.com" className="text-primary hover:underline">help@themanatomy.com</a>
            </p>
            <p><strong>Manatomy</strong></p>
          </section>
        </div>
      </div>
    </PublicLayout>
  );
};

export default CookiePolicy;
